import React from 'react';

const FaceAvatar = ({ index = 0, className = "w-10 h-10 rounded-full" }) => {
  // The image is a 3x3 grid. We map indexes 0-8 to their respective positions.
  const positions = [
    '0% 0%', '50% 0%', '100% 0%',       // Top row
    '0% 50%', '50% 50%', '100% 50%',    // Middle row
    '0% 100%', '50% 100%', '100% 100%'  // Bottom row
  ];
  
  const pos = positions[Math.max(0, Math.min(8, index))];
  
  return (
    <div 
      className={`shrink-0 overflow-hidden ${className}`}
      style={{
        backgroundImage: `url('https://media-manager-c.questera.ai/greta-media/25fe57c277fc4d49baa2815a1646d92e367cb2ce89a7d2c278a4f8202228d92c658a999133b0fffe7649687a42276768/images/aW1hZ2UvcG5n/4a3c68bbd111dfd698c9ee96af8acf2e.png')`,
        backgroundSize: '300% 300%', // 3x3 grid means image is 300% of container size
        backgroundPosition: pos,
        backgroundRepeat: 'no-repeat'
      }}
    />
  );
};

export default FaceAvatar;